// import Header from "../header/header";
import { useState} from "react";
import styles from "./main.module.css";
import ChartBoard from "./ChartBoard/main";
import Label from "./ChartBoard/label";
import { Flex, Link as UiLink, Box ,Heading} from "@chakra-ui/react";
import {
  AreaChart,
  Cell,
  Pie,
  PieChart,
  Area,
  CartesianGrid,
  ResponsiveContainer,
  XAxis,
  YAxis,
  Tooltip,
} from "recharts";
import { BarChart, Bar, Rectangle, Legend} from 'recharts';


import EventItem from "./EventItems/main";
import { Link } from "react-router-dom";
import { ReactComponent as ArrowRight } from "../../../svg/arrow.svg";
import apiCall from "../,,/../../../utils/apiCall";
import { useQueries, useQuery } from "react-query";
import { AxiosError, all } from "axios";
import { useEffect } from "react";


export interface DashboardProps {}

const areaDataColor = [
  {
    color: "#11643C",
    name: "Level 1",
  },
  {
    color: "#8DC467",
    name: "Level 2",
  },
  {
    color: "#5CA2D8",
    name: "Level 3",
  },
  {
    color: "#5CA2D8",
    name: "Level 4",
  },
  {
    color: "#5CA2D8",
    name: "Level 5",
  },
];

const areaData = [
  {
    name: "0",
    uv: 400,
    pv: 240,
    sv: 300,
    amt: 240,
  },
  {
    name: "1",
    uv: 300,
    pv: 139,
    sv: 300,
    amt: 221,
  },
  {
    name: "2",
    uv: 200,
    pv: 980,
    sv: 300,
    amt: 229,
  },
  {
    name: "3",
    uv: 278,
    pv: 390,
    sv: 800,
    amt: 200,
  },
  {
    name: "4",
    uv: 189,
    pv: 480,
    sv: 343,
    amt: 218,
  },
  {
    name: "5",
    uv: 239,
    pv: 380,
    sv: 700,
    amt: 250,
  },
  {
    name: "6",
    uv: 349,
    pv: 430,
    sv: 500,
    amt: 210,
  },
  {
    name: "7",
    uv: 349,
    pv: 430,
    sv: 500,
    amt: 210,
  },
  {
    name: "8",
    uv: 349,
    pv: 430,
    sv: 500,
    amt: 210,
  },
  {
    name: "9",
    uv: 349,
    pv: 430,
    sv: 500,
    amt: 210,
  },
  {
    name: "10",
    uv: 349,
    pv: 430,
    sv: 500,
    amt: 210,
  },
  {
    name: "11",
    uv: 349,
    pv: 430,
    sv: 500,
    amt: 210,
  },
];

const events = [
  {
    name: "HRM Examination",
    time: "9:00am",
    date: "07 Sep 2023",
  },
  {
    name: "HRM Examination",
    time: "9:00am",
    date: "07 Sep 2023",
  },
  {
    name: "HRM Examination",
    time: "9:00am",
    date: "07 Sep 2023",
  },
];

const barData = [
  {
    name: 'Page A',
    a: 4000,
    amt:'#0ff',
  },
  {
    name: 'Page B',
    a: 3000,
    amt: '#af0',
  },
  {
    name: 'Page C',
    a: 2000,
    amt:'#f0f',
  },
  {
    name: 'Page D',
    a: 3200,
    amt: '#90f'
  },
  {
    name: 'Page E',
    a: 4000,
    amt: '#0fa',
  },
  {
    name: 'Page F',
    a: 7000,
    amt: '#00f',
  },
  {
    name: 'Page G',
    a: 2300,
    amt: '#428bca'
  }

];


const Main = ({}: DashboardProps) => {
  const [ringdata,set_ringdata] = useState<any>([])
  const [piedata,set_piedata] = useState<any>([])
  const [areadata,set_areadata] = useState<any>([]);
  const [allEvent,set_allEvent] = useState<any>([]);
  const [bar_data,set_bar_data] = useState<any>([]);
  const {isLoading,data:all_data} = useQuery(['chart-data'],{
    queryFn:async ()=> await apiCall().get(`/ExamReport/studentsReport`),
    select(data:any){
      console.log(data,'chart data')
      return data.data.Data;
    }
  })
  const {data:all_ExamTimeTable} = useQuery(['exam-time-table'],{
    queryFn:async ()=> await apiCall().get(`/exam/setup/examTimeTable`),
    select(data){
      //console.log(data,'exam-table')
      return data.data.Data;
    }
  })
  useEffect(()=>{
      if(all_data){
        set_ringdata([
            { name: "Fully Paid", value: all_data?.FullyPaidDuesCount, color: "#11643C" },
            { name: "Owing", value: all_data?.OwingPaidDuesCount, color: "#FFCC00" },
          ])

          set_piedata([
            { name: "Registered", value: all_data?.ApplicationCount, color: "#4CAF4F" },
            { name: "Deferred", value: all_data?.DeferredApplicationCount, color: "#388DCC" },
          ])
          set_areadata( [
            {
              color: "#11643C",
              name: "LevelId: 2", value: all_data?.StudentCount
            },
            {
              color: "#8DC467",
              name: "LevelId: 4", Value: all_data?.StudentCount
            },
            {
              color: "#5CA2D8",
              name: "LevelId: 5", Value: all_data?.StudentCount
            },
            {
              color: "#5CA2D8",
              name: "LevelId: 6", Value: all_data?.StudentCount
            },
            {
              color: "#5CA2D8",
              name: "LevelId: 7", Value: all_data?.StudentCount
            },
          ])

          set_bar_data(all_data?.LevelReport?.map((eLevel:any,index:number)=>({...eLevel,color:barData[index]?.amt || '#428bca', Name:`Level ${index+1}`})))

      }
  },[all_data])

  

  useEffect(()=>{
    set_allEvent( all_ExamTimeTable && all_ExamTimeTable.length > 0?all_ExamTimeTable.slice(0,3):[] )

  },[all_ExamTimeTable])

  return (
    <main className={styles.container}>
      <div className={styles.wrapper}>
        <div className={styles.header}>
          <h1>Overview</h1>
        </div>

        <section >
          <ChartBoard header='Applications' className={styles.chartboard}>
            <Label labelArray={piedata} title="Applications"  total={all_data?.ApplicationCount + all_data?.DeferredApplicationCount} />

            <ResponsiveContainer width="100%" height="100%">
              <PieChart width={400} height={400}>
                <Pie
                  data={piedata}
                  cx="50%"
                  cy="50%"
                  startAngle={40}
                  endAngle={400}
                  outerRadius={125}
                  fill="#8884d8"
                  dataKey="value"
                  label
                >
                  {piedata.map((entry:any, index:any) => (
                    <Cell key={`cell-${index}`} fill={entry.color} />
                  ))}
                </Pie>

                <Tooltip />
              </PieChart>
            </ResponsiveContainer>
          </ChartBoard>

          <ChartBoard header='Dues'  className={styles.chartboard}>
            <Label labelArray={ringdata} title="Dues" total={all_data?.FullyPaidDuesCount + all_data?.OwingPaidDuesCount}  />

            <ResponsiveContainer width="100%" height="100%">
              <PieChart width={400} height={400}>
                <Pie
                  data={ringdata}
                  cx="50%"
                  cy="50%"
                  innerRadius={50}
                  outerRadius={125}
                  fill="#8884d8"
                  paddingAngle={0}
                  dataKey="value"
                  label
                >
                  {ringdata.map((entry:any, index:any) => (
                    <Cell key={`cell-${index}`} fill={entry.color} />
                  ))}
                </Pie>

                <Tooltip />
              </PieChart>
            </ResponsiveContainer>
          </ChartBoard>
        </section>

        <section>
          <div style={{backgroundColor:'var(--white-color)'}}>
            {/* <Label removeMargin={true} labelArray={areaDataColor} /> */}

            {/* <ResponsiveContainer width="100%" height="100%">
              <AreaChart width={730} height={250} data={areaData}>
                <defs>
                  <linearGradient id="colorUv" x1="0" y1="0" x2="0" y2="1">
                    <stop offset="5%" stopColor="#11643C" stopOpacity={0.8} />
                    <stop offset="95%" stopColor="#11643C" stopOpacity={0} />
                  </linearGradient>

                  <linearGradient id="colorPv" x1="0" y1="0" x2="0" y2="1">
                    <stop offset="5%" stopColor="#8DC467" stopOpacity={0.8} />
                    <stop offset="95%" stopColor="#8DC467" stopOpacity={0} />
                  </linearGradient>

                  <linearGradient id="colorSv" x1="0" y1="0" x2="0" y2="1">
                    <stop offset="5%" stopColor="#5CA2D8" stopOpacity={0.8} />
                    <stop offset="95%" stopColor="#5CA2D8" stopOpacity={0} />
                  </linearGradient>
                </defs>

                <XAxis dataKey="name" />

                <YAxis />

                <CartesianGrid strokeDasharray="30000 3" />

                <Tooltip />

                <Area
                  type="monotone"
                  dataKey="uv"
                  stroke="#11643C"
                  fillOpacity={1}
                  fill="url(#colorUv)"
                />

                <Area
                  type="monotone"
                  dataKey="pv"
                  stroke="#8DC467"
                  fillOpacity={1}
                  fill="url(#colorPv)"
                />

                <Area
                  type="monotone"
                  dataKey="sv"
                  stroke="#5CA2D8"
                  fillOpacity={1}
                  fill="url(#colorSv)"
                />
              </AreaChart>
            </ResponsiveContainer> */}
            <Heading p="20px" fontSize="20px" color="var(--dark-green-color)" >Students Distribution in Levels</Heading>
            {bar_data && bar_data.length > 0?<ResponsiveContainer width="100%" height="100%">
              <BarChart data={bar_data}
                width={500}
                height={300}
                margin={{
                  top: 5,
                  right: 30,
                  left: 20,
                  bottom: 5,
                }}
              >
                <CartesianGrid strokeDasharray="3 3" />
                <XAxis dataKey="Name"  />
                <YAxis />
                <Tooltip />
                <Legend />
                <Bar dataKey="StudentCount" fill="#8884d8">
                  {bar_data.map((eData:any,index:number)=><Cell
                  key={index} fill={eData.color} />)}
                </Bar>
              </BarChart>
            </ResponsiveContainer>:''}
            <Flex gap="20px" wrap="wrap">
            {bar_data.map((eData:any,index:number)=><Box fontSize="10px" key={index} as={Flex} gap="10px">
              <Box borderRadius="50%" w="15px" h="15px" bg={eData?.color}>
              </Box> {eData.LevelName}
            </Box>)}

          </Flex>
          </div>
         

          <div>
            <header>Upcoming Events</header>

            <div>
              {allEvent.map((item: any, index: number) => (
                <EventItem key={index} data={item} />
              ))}
            </div>

            <footer style={{display:'flex',margin:'0',padding:'0',gap:'5px',alignItems:'center'}}>
              <UiLink as={Link} to="/settings/exam-time-table">View more Events</UiLink>

              <ArrowRight />
            </footer>
          </div>
        </section>
      </div>
    </main>
  );
};

export default Main;


